import styled from "styled-components";

export const Background = styled.div`

@media (max-width: 600px){

}
   display: flex;
   flex-direction: column;
   justify-content: center;
   background: linear-gradient(#f1a9ca, #cbb9d9);
`
export const Image = styled.img`
@media (max-width: 767px){
    max-width: 70%;
    object-fit: cover;
    
}
    object-fit: fill;
`
export const Header1 = styled.h1`
@media (max-width: 767px){
    font-size: 2rem;
}
    font-family: 'Kinkee';
    font-size: 4rem;
    color: #794b9c;
    align-self: center;
`
export const Header2 = styled.h1`
@media (max-width: 767px){
    font-size: 1.5rem;
}
    font-family: 'Kinkee';
    font-size: 2rem;
    color: #794b9c;
`
export const Gradient = styled.div`
    background: linear-gradient(#f1a9ca, #cbb9d9);
    min-height: 50px;
`
export const OppGradient = styled.div`
    background: linear-gradient(#cbb9d9, #f1a9ca);
    min-height: 50px;
`

export const EmptySpace = styled.div`
    min-height: 50px;
`
export const ImageCard = styled.div`
    align-self: center;
    justify-self: center;
    text-align: center;
`
export const ImageDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`
export const Vid = styled.video`
    max-width: 800px;
    align-self: center;
    border-radius: 20px;
    @media (max-width: 767px) {
        max-width: 70%;
    }

`
